import * as countries from 'smg/countries';
import * as models from 'smg/models';
import * as template from 'smg/template';

export async function Draw(ute: models.UserTaxExemption, el?: HTMLElement): Promise<HTMLElement> {
    const newEl = el || template.Clone('#tax-exemption-template');

    const $state = newEl.querySelector<HTMLSpanElement>('.user-tax-exemption-state');
    const $number = newEl.querySelector<HTMLSpanElement>('.user-tax-exemption-number');
    const $reason = newEl.querySelector<HTMLSpanElement>('.user-tax-exemption-reason');

    if ($state) {
        let state = 'US';
        if (ute.countryID && ute.stateID) {
            state = (await countries.GetState(ute.countryID, ute.stateID))?.stateCode || 'US';
        }
        $state.textContent = state;
    }

    if ($number) {
        $number.textContent = ute.number || '';
    }

    if ($reason) {
        $reason.textContent = ute.userTaxExemptionReason?.name || '';
    }

    const $input = newEl.querySelector<HTMLInputElement>('input[type="radio"]');
    const $label = newEl.querySelector<HTMLLabelElement>('label');

    if ($input && $label) {
        $input.id = `user-tax-exemption-${ute.id ?? ''}`;
        $input.value = ute.id ?? '';
        $label.htmlFor = `user-tax-exemption-${ute.id ?? ''}`;
    }

    return newEl;
}
